import type { ComputedRef } from 'vue'
import type { Subscription } from '@entities/subscription'

import { formatSubscriptionDate } from './subscription-options'
import { isPausePlanned, isPauseStarted } from './subscription-rules'

interface UseSubscriptionStatusCellOptions {
  subscription: ComputedRef<Subscription>
}

interface SubscriptionStatusCellReturn {
  pausedUntilLabel: ComputedRef<string | null>
  plannedPauseLabel: ComputedRef<string | null>
}

export const useSubscriptionStatusCell = ({ subscription }: UseSubscriptionStatusCellOptions): SubscriptionStatusCellReturn => {
  const pausedUntilLabel = computed<string | null>(() => {
    const { paused_to: pausedTo } = subscription.value

    return pausedTo && isPauseStarted(subscription.value) ? `until ${formatSubscriptionDate(pausedTo)}` : null
  })

  const plannedPauseLabel = computed<string | null>(() => {
    const { paused_from: pausedFrom, paused_to: pausedTo } = subscription.value

    return pausedFrom && pausedTo && isPausePlanned(subscription.value)
      ? `Planned pause period: ${formatSubscriptionDate(pausedFrom)} - ${formatSubscriptionDate(pausedTo)}`
      : null
  })

  return {
    pausedUntilLabel,
    plannedPauseLabel,
  }
}
